// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDgjqKzDPjrVMlFnFGP_vLgdEgjf2WmtPg",
  authDomain: "hunt-by-nitzech.firebaseapp.com",
  databaseURL: "https://hunt-by-nitzech.firebaseio.com",
  projectId: "hunt-by-nitzech",
  storageBucket: "hunt-by-nitzech.appspot.com",
  messagingSenderId: "848842222795",
  appId: "1:848842222795:web:7a769e870a16845a6b3f4e",
  measurementId: "G-622SHB8GD7"
};

export default firebaseConfig;
